export default "__VITE_ASSET__45a749f2__"